/* T0'BLACK — Header interactions (no dependencies) */
(function () {
  var header = document.querySelector('[data-t0-header]');
  if (!header) return;

  /* Sticky shrink on scroll */
  if (header.classList.contains('is-sticky')) {
    var shrinkAt = 40;
    var ticking = false;
    var apply = function () {
      header.classList.toggle('is-shrunk', window.scrollY > shrinkAt);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(apply); ticking = true; }
    }, { passive: true });
    apply();
  }

  /* Back button */
  var backBtn = header.querySelector('[data-t0-back]');
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      var fallback = backBtn.getAttribute('data-fallback') || '/';
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = fallback;
      }
    });
  }

  /* Mobile drawer */
  var toggle = header.querySelector('[data-t0-toggle]');
  var drawer = document.querySelector('[data-t0-drawer]');
  if (!toggle || !drawer) return;

  var closeBtn = drawer.querySelector('[data-t0-close]');
  var open = function () {
    drawer.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  var close = function () {
    drawer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();
